/* eslint-disable jsx-a11y/label-has-associated-control */
import { Col } from "react-bootstrap";
import InputMask from "react-input-mask";

interface ICheckinProps {
    horarioInical: string;
    horarioFinal: string;
    setHorarioInicial: (value: string) => void;
    setHorarioFinal: (value: string) => void;
}

const CheckHorario = (e: string) => {
    const hora = e.split(":")[0];
    const minuto = e.split(":")[1];

    if (Number(hora) > 23 || Number(minuto) > 59) {
        return false;
    }
    if (!Number(hora + 1)) return false;
    // eslint-disable-next-line sonarjs/prefer-single-boolean-return
    if (!Number(minuto + 1)) return false;

    return true;
};

const CheckinRange: React.FC<ICheckinProps> = ({
    horarioInical,
    horarioFinal,
    setHorarioInicial,
    setHorarioFinal,
}) => {
    return (
        <>
            <Col>
                <div className="form-floating">
                    <InputMask
                        mask="99:99"
                        className="form-control"
                        id="HorarioInicial"
                        placeholder="00:00"
                        style={{
                            marginTop: 9,
                            width: 130,
                            color: CheckHorario(horarioInical)
                                ? "black"
                                : "red",
                            borderColor: CheckHorario(horarioInical)
                                ? "#787878"
                                : "red",
                        }}
                        value={horarioInical}
                        onBlur={() =>
                            CheckHorario(horarioInical)
                                ? null
                                : setHorarioInicial(`00:15`)
                        }
                        onChange={(e) => setHorarioInicial(e.target.value)}
                        required
                    />
                    <label
                        style={{
                            color: CheckHorario(horarioInical)
                                ? "black"
                                : "red",
                        }}
                        htmlFor="HorarioInicial"
                    >
                        Horário inicial
                    </label>
                </div>
            </Col>
            <Col>
                <div className="form-floating">
                    <InputMask
                        mask="99:99"
                        className="form-control"
                        id="HorarioFinal"
                        style={{
                            marginTop: 9,
                            width: 130,
                            color: CheckHorario(horarioFinal) ? "black" : "red",
                            borderColor: CheckHorario(horarioFinal)
                                ? "#787878"
                                : "red",
                        }}
                        placeholder="00:00"
                        value={horarioFinal}
                        onBlur={() =>
                            CheckHorario(horarioFinal)
                                ? null
                                : setHorarioFinal(`00:15`)
                        }
                        onChange={(e) => setHorarioFinal(e.target.value)}
                        required
                    />
                    <label
                        style={{
                            color: CheckHorario(horarioFinal) ? "black" : "red",
                        }}
                        htmlFor="HorarioFinal"
                    >
                        Horário final
                    </label>
                </div>
            </Col>
        </>
    );
};

export default CheckinRange;
